import { API } from 'aws-amplify';

import {
	FETCH_CU_SMELTER_PRODUCTION,
	FETCH_CU_SMELTER_PRODUCTION_ERR,
	RESET_CU_SMELTER_PRODUCTION,
	FETCH_CU_MTD_PRODUCTION,
	FETCH_CU_MTD_PRODUCTION_ERR,
	FETCH_CU_PRODUCTION_BY_SMELTER,
	FETCH_CU_PRODUCTION_BY_SMELTER_ERR,
	RESET_CU_PRODUCTION_BY_SMELTER,
	SELECT_CU_PROD_SMELTER,
	UNSELECT_CU_PROD_SMELTER,
	RESET_CU_PROD_SMELTERS
} from '../';
import config from '../../config';
import { replacer } from '../../utils';

export const fetchCuSmelterProduction =
	({
		grouping,
		id = '',
		collapse,
		ute = '',
		capAdd = '',
		startDate = '',
		endDate = ''
	}) =>
	async (dispatch) => {
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.cuSmelterProduction, {
				grouping,
				id,
				collapse,
				ute,
				capAdd,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				dispatch({
					type: FETCH_CU_SMELTER_PRODUCTION,
					payload: {
						[collapse]:
							response.combinedIdx || response.singleIdx[0]?.data || []
					}
				});
			},
			(err) =>
				dispatch({
					type: FETCH_CU_SMELTER_PRODUCTION_ERR,
					payload: err
				})
		);
	};
export const resetCuSmelterProduction = () => (dispatch) =>
	dispatch({ type: RESET_CU_SMELTER_PRODUCTION });

export const fetchCuMtdProduction =
	({ grouping, id = '', ute = '' }) =>
	async (dispatch) => {
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.cuMtdProduction, {
				grouping,
				id,
				ute
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				dispatch({
					type: FETCH_CU_MTD_PRODUCTION,
					payload: response
				});
			},
			(err) =>
				dispatch({
					type: FETCH_CU_MTD_PRODUCTION_ERR,
					payload: err
				})
		);
	};

export const resetCuMtdProduction = () => ({
	type: FETCH_CU_MTD_PRODUCTION,
	payload: []
});

export const fetchCuProductionBySmelter =
	({ ids, collapse, ute = '', startDate = '', endDate = '' }) =>
	async (dispatch) => {
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.cuProductionBySmelters, {
				ids,
				collapse,
				ute,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) =>
				dispatch({
					type: FETCH_CU_PRODUCTION_BY_SMELTER,
					payload: response
				}),
			(err) =>
				dispatch({
					type: FETCH_CU_PRODUCTION_BY_SMELTER_ERR,
					payload: err
				})
		);
	};

export const resetCuProductionBySmelter = () => ({
	type: RESET_CU_PRODUCTION_BY_SMELTER,
	payload: {}
});

export const selectCuProdSmelter = (key) => ({
	type: SELECT_CU_PROD_SMELTER,
	payload: key
});

export const unselectCuProdSmelter = (key) => ({
	type: UNSELECT_CU_PROD_SMELTER,
	payload: key
});

export const resetCuProdSmelters = () => ({
	type: RESET_CU_PROD_SMELTERS
});
